import { Link } from "react-router-dom"
import { track } from "@/lib/analytics"
import { requireLogin, useAuthGate } from "@/lib/authGate"

export type SuggestedSimulator = "oio_sim" | "oia_sim"

const TARGETS: Record<SuggestedSimulator, { route: string; title: string; sub: string }> = {
  oio_sim: { route: "/oio-sim", title: "OIO simulator", sub: "Draft the order from the notice and reply." },
  oia_sim: { route: "/oia-sim", title: "OIA simulator", sub: "Draft the appellate order from the appeal." },
}

/** Under an answer: offers the order simulator that fits the question, with the question prefilled. */
export function SimSuggestionCard({ simulator, question }: { simulator: SuggestedSimulator; question: string }) {
  const { signedIn } = useAuthGate()
  const t = TARGETS[simulator]
  const to = question ? `${t.route}?q=${encodeURIComponent(question)}` : t.route
  return (
    <aside className="sim-suggest" aria-label="Suggested simulator">
      <span className="sim-suggest__lab">Drafting an order?</span>
      <Link
        to={to}
        className="sim-suggest__link"
        onClick={(e) => {
          // The door a drafting question ends on (the OPA policy makes the answer end here).
          track("sim_suggestion_clicked", { simulator, signed_in: signedIn })
          if (signedIn) return
          e.preventDefault()
          requireLogin("simulator", to)
        }}
      >
        <span className="sim-suggest__t">{t.title}</span>
        <span className="sim-suggest__sub">{t.sub}</span>
      </Link>
    </aside>
  )
}
